export default function (brandName: string) {
  const { $sitewideConfig } = useNuxtApp()
  if (!brandName || !$sitewideConfig.config.madeByRealTruckEnabled) return false

  return !!(
    $sitewideConfig.config.madeByRealTruckBrands?.data.includes(brandName) ||
    $sitewideConfig.config.madeByRealTruckOnlineOnlyBrands?.data.includes(brandName)
  )
}
